// Splash — full-bleed paper background with a single Han-text line.
// Used by App.tsx for auth / event-config loading states. Pulled out
// of App.tsx so AuthGate's flow reads cleanly.

import { Han, T } from "@goodbye/ui";

export function Splash({ children }: { children: React.ReactNode }) {
  return (
    <div
      style={{
        minHeight: "100dvh",
        display: "grid",
        placeItems: "center",
        background: T.paper,
        padding: 40,
        textAlign: "center",
      }}
    >
      <Han size={14} color={T.ink500} lh={1.8}>
        {children}
      </Han>
    </div>
  );
}
